import React, {useCallback, useEffect, useRef, useState} from "react";
import "./gestion-saisie-de-paiement.css"
import {TransactionType} from "../gestion-paiement/gestion-paiement";
import Guid from "../../models/Guid";
import useApi from "../../hooks/useApi";
import IClient from "../../models/IClient";
import TextBox, {TextBoxRef} from "devextreme-react/text-box";
import CarteCredit from "../../components/carte-credit/carte-credit";
import IPaiementProfile from "../../models/IPaiementProfile";
import IPaiement from "../../models/IPaiement";


const buttonAttributes = {
    class: 'popup-depot-bouton-cta'
}

interface GestionSaisieDePaiementProps {
    setIsSaisiePaiement: (shouldClose: boolean) => void; // Define onClose as a function that doesn't take any arguments and doesn't return anything
    onConfirm?: (e: { e: React.MouseEvent<HTMLButtonElement>, montant: number, cardNumber: string, cardExpiration: string, cardVcc: string, cardToken: string, typePaiement: TransactionType, nomClient: string, ProfilePaiement?: IPaiementProfile, noTransaction: string }) => void
    showSaisieCarte: boolean,
    montantDu: number,
    idClient?: Guid,
    currentPaiement?: IPaiement
}

export enum IssuerCode {
    VISA = 1,
    VISA_PURCHASING = 2,
    MASTERCARD = 3,
    MASTERCARD_PURCHASING = 4,
    JCB = 5,
    AMEX = 6,
    DINES = 7,
    DISCOVER = 8,
    INTERAC = 9,
    US_DEBIT = 10,
    VIDE = 11
}

const GestionSaisieDePaiement = ({setIsSaisiePaiement, onConfirm, showSaisieCarte, montantDu, idClient, currentPaiement}: GestionSaisieDePaiementProps) => {
    const [montant, setMontant] = useState<string>(`${montantDu}`);
    const [textHistory, setTextHistory] = useState<string[]>([]);
    const [currentHistoryIndex, setCurrentHistoryIndex] = useState(-1);
    const [montantHistory, setMontantHistory] = useState<string[]>([]);
    const [montantHistoryIndex, setMontantHistoryIndex] = useState(-1);
    const [montantPlus, setMontantPlus] = useState('');
    const [montantType, setMontantType] = useState(true);
    const [noTransaction, setNoTransaction] = useState('');
    const [isNoTransactionFocused, setIsNoTransactionFocused] = useState(false);
    const [carteType, setCarteType] = useState(true);
    const [typeTransaction, setTypeTransaction] = useState<TransactionType>(TransactionType.Purchase);
    const [lastBtn, setLastBtn] = useState<String>('');
    const cardNumberRef = useRef<TextBoxRef>(null);
    const cardExpirationRef = useRef<TextBoxRef>(null);
    const cardVccRef = useRef<TextBoxRef>(null);
    const nomClientRef = useRef<HTMLInputElement | null>(null);
    const [ProfilePaiement, setProfilePaiement] = useState<IPaiementProfile>();
    const {data: cliennt, getData: getclient} = useApi<IClient>("client");

    const handleButtonClick = (value: String) => {
        setLastBtn(value);
        if (isNoTransactionFocused) {
            if (textHistory.length === 0 || noTransaction !== textHistory[currentHistoryIndex]) {
                setTextHistory([...textHistory.slice(0, currentHistoryIndex + 1), noTransaction]);
                setCurrentHistoryIndex((prevIndex) => prevIndex + 1);
            }
            setNoTransaction((prevText) => prevText + value);
        } else if (montantType) {
            if (!value)
                setMontant('')
            else if (value == '-')
                setMontant((prevResult) => (-Number(prevResult)).toString());
            else if (value == '<-')
                setMontant((prevResult) => prevResult.slice(0, -1));
            else
                setMontant((prevResult) => prevResult + value);
            // if (montantHistory.length === 0 || montant !== montantHistory[montantHistoryIndex]) {
            //   setMontantHistory([...montantHistory.slice(0, montantHistoryIndex + 1), montant]);
            //   setMontantHistoryIndex((prevIndex) => prevIndex + 1);
            // }
        } else {
            if (!value)
                setMontantPlus('')
            else if (value == '-')
                setMontantPlus((prevResult) => (-Number(prevResult)).toString());
            else if (value == '<-')
                setMontant((prevResult) => prevResult.slice(0, -1));
            else
                setMontantPlus((prevResult) => prevResult + value);
        }
    };

    const clearResult = () => {
        setLastBtn('x');
        if (isNoTransactionFocused)
            setNoTransaction('');
        else if (montantType)
            setMontant('');
        else
            setMontantPlus('');
    };

    const handleTextAreaFocus = () => {
        setIsNoTransactionFocused(true);
    };

    const handleTextAreaBlur = () => {
        setIsNoTransactionFocused(false);
    };

    const handleUndo = () => {
        if (isNoTransactionFocused) {
            if (currentHistoryIndex > 0) {
                setCurrentHistoryIndex((prevIndex) => prevIndex - 1);
                setNoTransaction(textHistory[currentHistoryIndex - 1]);
            }
        }
    };

    const onBtnClick = (type: TransactionType) => {
        setNoTransaction('');
        setTypeTransaction(type);
    }

    const isTextDisabled = !([TransactionType.PreauthCompletion, TransactionType.Refund] as TransactionType[]).includes(typeTransaction);
    useEffect(() => {
        getclient({customPath: `client/${idClient}`}).then(client => {
            if (nomClientRef && nomClientRef.current)
                nomClientRef.current.value = `${client.prenom} ${client.nom}`
        })
    }, [nomClientRef]);

    useEffect(() => {
        switch (typeTransaction) {
            case TransactionType.PreauthCompletion:
            case TransactionType.Refund:
                setMontant((currentPaiement?.montant || 0).toString())
                const reference = currentPaiement?.reference?.split(':') || [];
                const referenceNumber = reference[1] || reference[0]
                setNoTransaction(referenceNumber || '');
                break;
            default:
                break;
        }
    }, [typeTransaction]);

    const onCarteCreditChanged = useCallback((profilePaiement?: IPaiementProfile) => {
        setProfilePaiement(profilePaiement);
    }, []);

    const onNoTransactionChange = useCallback((e: any) => {
        if (textHistory.length === 0 || noTransaction !== textHistory[currentHistoryIndex]) {
            setTextHistory([...textHistory.slice(0, currentHistoryIndex + 1), noTransaction]);
            setCurrentHistoryIndex((prevIndex) => prevIndex + 1);
        }
        setNoTransaction(e.target.value);
    }, [noTransaction, currentHistoryIndex]);

    const onOkClick = useCallback((e: any) => onConfirm && onConfirm({
        e,
        montant: Number(montant),
        typePaiement: typeTransaction,
        cardNumber: cardNumberRef.current?.instance().option("text") || "",
        cardExpiration: cardExpirationRef.current?.instance().option("text") || '',
        cardVcc: cardVccRef.current?.instance().option("text") || "",
        cardToken: "",
        nomClient: nomClientRef.current?.value || '',
        ProfilePaiement: carteType ? ProfilePaiement : undefined,
        noTransaction: noTransaction
    }), [onConfirm, montant, typeTransaction, ProfilePaiement, carteType]);

    return (
        <div className='wrapper-content-pop'>
            <div style={{flex: 1}}>
                <div className="container-saisie-paiement" id="calcul-saisie">
                    <div className="box-saisie-paiement">
                        <table>
                            <tbody>
                            <tr>
                                <td colSpan={3} style={{textAlign: 'center'}}>
                                    Montant de la transaction
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={3} style={{textAlign: 'center'}}>
                                    <input type="text" id="montant" placeholder="0.00"
                                           style={{backgroundColor: montantType ? '#fdf5e6' : 'white'}}
                                           onClick={() => {
                                               setMontantType(true);
                                               setIsNoTransactionFocused(false);
                                           }}
                                           onChange={(e) => setMontant(e.target.value)}
                                           value={montant}
                                        // style={{ backgroundColor: montantType && '#fdf5e6' }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={3} style={{textAlign: 'center'}}>
                                    Montant additionnel
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={3} style={{textAlign: 'center'}}>
                                    <input type="text" id="montantPlus" placeholder="0.00"
                                           style={{backgroundColor: !montantType ? '#fdf5e6' : 'white', cursor: 'pointer'}}
                                           onClick={() => {
                                               setMontantType(false);
                                               setIsNoTransactionFocused(false);
                                           }}
                                           value={montantPlus} readOnly
                                        // style={{ backgroundColor: !montantType && '#fdf5e6' }}
                                    />
                                </td>
                            </tr>

                            <tr>
                                <td><input type="button" className={`${lastBtn == '7' && 'btn-holded'}`} value="7" onClick={() => handleButtonClick('7')}/></td>
                                <td><input type="button" className={`${lastBtn == '8' && 'btn-holded'}`} value="8" onClick={() => handleButtonClick('8')}/></td>
                                <td><input type="button" className={`${lastBtn == '9' && 'btn-holded'}`} value="9" onClick={() => handleButtonClick('9')}/></td>
                            </tr>
                            <tr>
                                <td><input type="button" className={`${lastBtn == '4' && 'btn-holded'}`} value="4" onClick={() => handleButtonClick('4')}/></td>
                                <td><input type="button" className={`${lastBtn == '5' && 'btn-holded'}`} value="5" onClick={() => handleButtonClick('5')}/></td>
                                <td><input type="button" className={`${lastBtn == '6' && 'btn-holded'}`} value="6" onClick={() => handleButtonClick('6')}/></td>
                            </tr>
                            <tr>
                                <td><input type="button" className={`${lastBtn == '1' && 'btn-holded'}`} value="1" onClick={() => handleButtonClick('1')}/></td>
                                <td><input type="button" className={`${lastBtn == '2' && 'btn-holded'}`} value="2" onClick={() => handleButtonClick('2')}/></td>
                                <td><input type="button" className={`${lastBtn == '3' && 'btn-holded'}`} value="3" onClick={() => handleButtonClick('3')}/></td>
                            </tr>
                            <tr>
                                <td><input type="button" className={`${lastBtn == '0' && 'btn-holded'}`} value="0" onClick={() => handleButtonClick('0')}/></td>
                                <td><input type="button" className={`${lastBtn == '.' && 'btn-holded'}`} value="." disabled={isNoTransactionFocused} onClick={() => handleButtonClick('.')}/></td>
                                <td><input type="button" className={`${lastBtn == '00' && 'btn-holded'}`} value="00" disabled={isNoTransactionFocused} onClick={() => handleButtonClick('00')}/></td>
                            </tr>
                            <tr>
                                <td><input type="button" className={`${lastBtn == '-' && 'btn-holded'}`} value="-" disabled={isNoTransactionFocused} onClick={() => handleButtonClick('-')}/></td>
                                <td><input type="button" className={`${lastBtn == '<-' && 'btn-holded'}`} value="<-"
                                           onClick={() => isNoTransactionFocused
                                               ? handleUndo()
                                               : handleButtonClick('<-')
                                           }/></td>
                                <td><input type="button" className={`${lastBtn == 'x' && 'btn-holded'}`} value="x" onClick={() => clearResult()}/></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="box-saisie-paiement" style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
                        <div style={{...showSaisieCarte ? {} : {display: "none"}}}>
                            <label style={{cursor: 'pointer'}} onClick={() => setCarteType(true)}>
                                <div style={{display: "flex", flexDirection: "row"}}>
                                    <span>Carte se terminant par </span>
                                    <CarteCredit isModeModifier={true} idClient={idClient || Guid.empty} idProfileSelected={ProfilePaiement?.idPaiementProfile} onChanged={onCarteCreditChanged} afficherOptionAjouterEffacer={true}/>
                                </div>
                            </label>
                            <input className="input" type="radio" name="carte" checked={carteType} onChange={() => {
                                setCarteType(true)
                            }}/>
                            <br/>
                            <label style={{cursor: 'pointer', ...showSaisieCarte ? {} : {display: "none"}}}
                                   onClick={() => setCarteType(false)}
                            > Autre carte
                            </label>
                            <input className="input"
                                   type="radio"
                                   name="carte"
                                   checked={!carteType}
                                   onChange={() => {
                                       setCarteType(false)
                                   }}
                            />
                            <div style={{display: "flex", marginTop: "1rem", flexDirection: "column", gap: "1rem"}}>
                                <div style={{display: "flex", gap: "1rem", alignItems: "center"}}>
                                    <label style={carteType ? {filter: 'saturate(0) contrast(10%) brightness(110%)'} : {}}>Nom du client</label>
                                    <input ref={nomClientRef} className="input" type="text" disabled={carteType}/>
                                </div>
                                <div className="container" style={{display: "flex", gap: "5px"}}>
                                    <TextBox ref={cardNumberRef}
                                             style={{width: '55%', fontSize: '1rem'}}
                                             mask={"0000 0000 0000 0009"}
                                             maskChar={""}
                                             disabled={carteType} readOnly={carteType}/>
                                    <TextBox ref={cardExpirationRef}
                                             style={{width: '80px', height: "100%", fontSize: '1rem'}}
                                             placeholder="00-00"
                                             maskChar={""}
                                             mask={"00-00"} maskRules={{
                                        0: (char: string, index: number, fullStr: any) => {
                                            const year = parseInt(new Date().getFullYear().toString().slice(-2))
                                            const month = new Date().getMonth() + 1;
                                            if (index === 0) {
                                                return [0, 1].includes(parseInt(char))
                                            }

                                            if (index === 3) {
                                                return [2, 3, 4, 5, 6, 7, 8, 9].includes(parseInt(char))
                                            }
                                            if (index === 4) {
                                                return parseInt(fullStr[3] + char) > year || parseInt(fullStr[3] + char) === year && parseInt(fullStr.slice(0, 2)) >= month
                                            }

                                            return [[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].includes(parseInt(char))]
                                        }
                                    }}
                                             disabled={carteType} readOnly={carteType}/>
                                    <TextBox ref={cardVccRef}
                                             style={{width: '35%', fontSize: '1em'}}
                                             maskChar={""}
                                             mask={"0009"}
                                             disabled={carteType} readOnly={carteType}/>
                                </div>
                            </div>
                            <br/>
                        </div>
                        <div className="container">
                            <button
                                className={`custom-button-saisie ${typeTransaction === TransactionType.Purchase && 'btn-holded'}`}
                                onClick={() => onBtnClick(TransactionType.Purchase)}
                                style={{height: '75px'}}
                            >
                                {typeTransaction === TransactionType.Purchase &&
                                    <span className="arrow-saisie">&#x2713;</span>
                                }
                                Vente
                            </button>
                            <button
                                className={`custom-button-saisie ${typeTransaction == TransactionType.Refund && 'btn-holded'}`}
                                onClick={() => onBtnClick(TransactionType.Refund)}
                                style={{height: '75px'}}
                            >
                                {typeTransaction == TransactionType.Refund &&
                                    <span className="arrow-saisie">&#x2713;</span>
                                }
                                Remboursement
                            </button>
                        </div>
                        <div className="container-align">
                            <button
                                className={`custom-button-saisie ${typeTransaction == TransactionType.Preauth && 'btn-holded'}`}
                                onClick={() => onBtnClick(TransactionType.Preauth)}
                            >
                                {typeTransaction == TransactionType.Preauth &&
                                    <span className="arrow-saisie">&#x2713;</span>
                                }
                                Pré-autorisation
                            </button>
                            <button
                                className={`custom-button-saisie ${typeTransaction == TransactionType.PreauthCompletion && 'btn-holded'}`}
                                onClick={() => onBtnClick(TransactionType.PreauthCompletion)}
                            >
                                {typeTransaction == TransactionType.PreauthCompletion &&
                                    <span className="arrow-saisie">&#x2713;</span>
                                }
                                Complèter pré-autorisation
                            </button>
                        </div>
                        <div className="container">
                            <span style={isTextDisabled ? {filter: 'saturate(0) contrast(10%) brightness(110%)'} : {}}>Transaction #</span>
                        </div>
                        <div style={{flex: 1, alignSelf: "stretch", display: "flex", justifyContent: "center"}}>
                            <textarea style={{width: '90%', height: '100%'}} value={noTransaction} onChange={onNoTransactionChange} onFocus={handleTextAreaFocus} disabled={isTextDisabled}/>
                        </div>
                        <div className="container">
                            <button className="custom-button-saisie with-color" onClick={onOkClick}>OK</button>
                            <button className="custom-button-saisie with-color" onClick={() => setIsSaisiePaiement(false)}>ANNULER</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GestionSaisieDePaiement;